module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('keep-alive', [_c('router-view')], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "toTop",
    on: {
      "click": _vm.goToTop
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/gotop.png")
    }
  })]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6bb170c7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/App.vue
// module id = 1535
// module chunks = 18